<template>
  <rkm-modal :buttons="['cancel']" large ref="ModalLotacoes" title="Lotações">
    <rkm-alert show info>
      <strong>Usuário:</strong>
      {{ nomeUsuario }}
    </rkm-alert>

    <div class="m-2 text-center" v-if="emptyData">Por enquanto nenhuma lotação foi cadastrada para este usuário!</div>

    <rkm-table
      v-else
      :fields="fields.tables.lotacoes"
      :items="items"
      hide-filters
      hide-pagination
      hover
      striped
    >
    </rkm-table>
  </rkm-modal>
</template>

<script>
// Mixins.
import { error, repository } from "@/mixins";

// Vuex.
import { mapActions } from "vuex";

// Enums.
import preferenciaNome from "@/enums/cadastro/cidadao/preferenciaNome";

export default {
  computed: {
    fields() {
      return {
        tables: {
          lotacoes: [
            { key: "unidade", label: "Unidade" },
            { key: "codigo", label: "Código" },
            { key: "ocupacao", label: "Ocupação" },
          ],
        },
      };
    },
  },
  created() {
    this.repositories.usuario = this.getConectaSusRepository(
      "cadastro.sujeitoAtencao.usuario"
    );
  },
  data: () => ({
    items: [],
    model: {
      nomePaciente: null,
      preferenciaNomeId: null,
      nomeSocial: null,
    },
    enums: { preferenciaNome },
    repositories: {
      usuario: null,
    },
    nomeUsuario: "",
    emptyData: true,
  }),
  methods: {
    ...mapActions(["setLoading", "unsetLoading"]),
    open(item) {
      this.nomeUsuario = item.nome;
      this.repositories.usuario
        .lotacoes(item.id)
        .then((response) => {
          this.items = response.data.map((item) => ({
            id: item.id,
            unidade: item.unidade,
            codigo: item.codigo,
            ocupacao: item.ocupacao,
          }));

          this.emptyData = !this.items.length;
        })
        .catch((error) => {
          console.error(error);
          this.emptyData = true;
        })
        .finally(() => {
          this.$refs.ModalLotacoes.show();
        });
    },
  },
  mixins: [error, repository],
};
</script>
